import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "verifikasiTunjanganKhusus";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const verifikasiTunjanganKhususCreate =
  "Kepegawaian/VerifikasiTunjanganKhusus/create/";
export const verifikasiTunjanganKhususList =
  "Kepegawaian/VerifikasiTunjanganKhusus/list/";
export const verifikasiTunjanganKhususUpdate =
  "Kepegawaian/VerifikasiTunjanganKhusus/update/";

// function aries
export const verifikasiTunjanganKhususGenerate =
  "Kepegawaian/VerifikasiTunjanganKhusus/generate/";

export const verifikasiTunjanganKhususVerifikasi =
  "Kepegawaian/VerifikasiTunjanganKhusus/verifikasi/";
export const verifikasiTunjanganKhususCekVerifikasi =
  "Kepegawaian/VerifikasiTunjanganKhusus/cekVerifikasi/";

export const masterWorkUnit = "Master/List/workUnit/";
export const listAtasan = "Kepegawaian/VerifikasiTunjanganKhusus/listAtasan/";

export const exportExcel = "Kepegawaian/VerifikasiTunjanganKhusus/exportExcel/";

// function create assestment
export const detailSpecialAllowance =
  "Kepegawaian/VerifikasiTunjanganKhusus/detailSpecialAllowance/";
export const createSpecialAllowance =
  "Kepegawaian/VerifikasiTunjanganKhusus/createSpecialAllowance/";
export const listComponent =
  "Kepegawaian/VerifikasiTunjanganKhusus/listPenilaiain/";
export const listCriteria =
  "Kepegawaian/VerifikasiTunjanganKhusus/listCriteria/";
export const detailBobot = "Kepegawaian/VerifikasiTunjanganKhusus/detailBobot/";

export const openVerification = 'Kepegawaian/VerifikasiTunjanganKhusus/openverification/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
